export function createCheckoutSession({ token, price, axiosPrivate }) {
    return axiosPrivate('/stripe/create-checkout-session', {
        method: 'POST',
        headers: { authorization: `Bearer ${token}` },
        data: { price },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}
